import Vue from 'vue'
import VueRouter from 'vue-router'
import baseTpl from "../helpers/baseTpl";
import m_header from '../components/m_header/m_header.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: m_header,
    children: [
      {
        path: '/',//首页
        name: 'Mindex',
        component: () => import('../views/mobile/index/m_index.vue'),
        meta: {
          isMobile: true,
          search: true,//搜索
          banner: true,
          menubar: true, //菜单
        },
      },
      {
        path: '/m_search',//搜索
        name: 'Msearch',
        component: () => import('../views/mobile/search/m_search.vue'),
        meta: {
          isMobile: true,
          back: true,//返回
          title: '搜索',
          menubar: true, //菜单
        },
      },
      {
        path: '/m_imgTextList',//大图精览列表页
        name: 'MimgTextList',
        component: () => import('../views/mobile/imgTextList/m_list.vue'),
        meta: {
          isMobile: true,
          back: true,//返回
          search: true,//搜索
          banner: false,
          menubar: true, //菜单
        },
      },
      {
        path: '/m_imgTextDetail',//大图精览详情页
        name: 'MimgTextDetail',
        component: () => import('../views/mobile/imgTextDetail/m_detail.vue'),
        meta: {
          isMobile: true,
          back: true,//返回
          banner: false,
          menubar: true, //菜单
          search: true,//搜索
        },
      },
      {
        path: '/m_preview',//预览
        name: 'Mprivate',
        component: () => import('../views/mobile/preview/m_preview.vue'),
        meta: {
          isMobile: true,
          back: true,//返回
          search: true,//搜索
        },
      },
      {
        path: '/m_videoList',//视频列表
        name: 'MvideoList',
        component: () => import('../views/mobile/videoList/m_list.vue'),
        meta: {
          isMobile: true,
          back: true,//返回
          banner: false,
          menubar: true, //菜单
          search: true,//搜索
        },
      },
      {
        path: '/m_videoListNew',//视频列表
        name: 'MvideoList',
        component: () => import('../views/mobile/videoListNew/m_list.vue'),
        meta: {
          isMobile: true,
          back: true,//返回
          banner: false,
          menubar: true, //菜单
          search: true,//搜索
        },
      },
      {
        path: '/m_videoListMore',//视频列表
        name: 'MvideoListMore',
        component: () => import('../views/mobile/videoListMore/m_list.vue'),
        meta: {
          isMobile: true,
          back: true,//返回
          banner: false,
          menubar: true, //菜单
          search: true,//搜索
        },
      },
      {
        path: '/m_videoDetail',//视频详情
        name: 'MvideoDetail',
        component: () => import('../views/mobile/videoDetail/m_detail.vue'),
        meta: {
          isMobile: true,
          back: true,//返回
          banner: false,
          menubar: true, //菜单
          search: true,//搜索
        },
      },
      {
        path: '/m_collectionStory',//藏品故事
        name: 'MonlineChose',
        component: () => import('../views/mobile/collectionStory/m_collectionStory.vue'),
        meta: {
          isMobile: true,
          back: true,//返回
          banner: false,
          menubar: true, //菜单
          search: true,//搜索
        },
      },
      {
        path: '/m_museumDetails',//博物馆详情
        name: 'McollectionStory',
        component: () => import('../views/mobile/museumDetails/m_detail.vue'),
        meta: {
          isMobile: true,
          back: true,//返回
          menubar: true, //菜单
          search: true,//搜索
        },
      },
      {
        path: '/m_onlineChose',//在线选购
        name: 'McollectionStory',
        component: () => import('../views/mobile/onlineChose/m_onlineChose.vue'),
        meta: {
          isMobile: true,
          back: true,//返回
          menubar: true, //菜单
          search: true,//搜索
        },
      },
    ],
  },



]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes
})

router.beforeEach((to, from, next) => {
  baseTpl.prototype.setMobileRem(to)
  next()
})

export default router
